// extracted by mini-css-extract-plugin
export default {"item":"QuickLinks_item__JZtzk"};